import {
  InstallmentList,
  InstallmentSettleFormValues,
  InstallmentSettleMultipleRequest,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';
import { Button, Form, Modal, ModalProps } from 'antd';
import React from 'react';
import SettleMultipleInstallmentForm from './SettleMultipleInstallmentForm';
import moment from 'moment';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { DateTimeFormat } from '@/utils/moment';
import { useInstallmentSettledMultiple } from '@/core/domain/financial/AccountPayable/AccountPayable.hooks';

interface Props extends ModalProps {
  installmentsSelected?: InstallmentList[];
  onOk: VoidFunction;
  onCancel: VoidFunction;
}

const SettledMultipleModal: React.FC<Props> = ({
  onOk,
  onCancel,
  open,
  installmentsSelected,
}) => {
  const [form] = Form.useForm<InstallmentSettleFormValues>();

  const settleMultipleMutation = useInstallmentSettledMultiple();

  const today = moment().format('YYYY-MM-DD');
  const payDate = Form.useWatch('payDate', form);

  const isEarlierDate = moment(payDate).isBefore(today);

  const handleSettleMultipleInstallments = async () => {
    const values = await form.validateFields();

    if (installmentsSelected?.length) {
      const obj: InstallmentSettleMultipleRequest = {
        ...values,
        payDate: values.payDate.format(DateTimeFormat),
        accountPayableIds: installmentsSelected.map(
          (installment) => installment.accountPayableId,
        ),
        installmentPayableId: installmentsSelected.map(
          (installment) => installment.id,
        ),
        discountIncrease: values.discountIncrease,
      };

      await settleMultipleMutation.mutateAsync(obj);

      form.resetFields();

      onOk();
    }
  };

  return (
    <Modal
      width={400}
      open={open}
      onCancel={onCancel}
      title="Liquidar Multiplas Parcelas"
      footer={
        <SpaceForButton justifyContent="flex-end">
          <Button type="primary" ghost onClick={onCancel}>
            Cancelar
          </Button>

          <Button
            disabled={
              isEarlierDate &&
              !hasPermissions([
                Authorities.FINANCIAL_ACCOUNT_PAYABLE_SETTLE_REFUND_WITH_PREVIOUS_DATE,
              ])
            }
            type="primary"
            loading={settleMultipleMutation.isLoading}
            onClick={handleSettleMultipleInstallments}
          >
            Liquidar
          </Button>
        </SpaceForButton>
      }
      destroyOnClose
    >
      <SettleMultipleInstallmentForm
        installments={installmentsSelected}
        form={form}
      />
    </Modal>
  );
};

export default SettledMultipleModal;
